import { captureExceptionWithoutPhi } from "@/utils/sentry";

/**
 * Reports a capture whose charges were written but whose inferred Location move failed.
 *
 * Goes to Sentry without a toast: the charges are in, and the next capture moves them. Only the
 * encounter's id reaches Sentry.
 *
 * @param encounterId - The encounter whose charges kept the old Location.
 * @param placeOfServiceRefreshFailure - The message the failed move came back with.
 */
export function reportPlaceOfServiceRefreshFailure(
  encounterId: string,
  placeOfServiceRefreshFailure: string,
): void {
  captureExceptionWithoutPhi(
    "Captured the encounter's charges but failed to move their inferred Location",
    new Error(placeOfServiceRefreshFailure),
    { encounterId },
  );
}
